(function () {
    angular.module('st')
        .controller('CRewardsTopNavCtrl', [
            '$rootScope', '$scope', '$sce', '$http',
            function ($rootScope, $scope, $sce, $http) {
                var ctrl = this;
                var DEFAULT_TIER = {
                    name: 'basic',
                    icon: ' \
                   <svg width="50px" height="44px" viewBox="0 0 50 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns: xlink = "http://www.w3.org/1999/xlink" > \
                        <g id="Menu" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\
                            <g id="Menu---Signed-In---More-Shows" transform="translate(-811.000000, -45.000000)" fill="#8D6708" stroke="#8D6708" stroke-width="0.5">\
                                <g id="Membership" transform="translate(812.000000, 45.000000)">\
                                    <g id="Guitar-Picks" transform="translate(0.000000, 1.000000)">\
                                        <path d="M33.9019535,31.8864 C32.0690233,33.97016 30.9884651,34.25744 30.096,34.25744 C29.4485581,34.25744 28.4506047,33.62632 27.9605581,32.9084 L27.8483721,32.74376 C30.1166512,27.25576 32.4106047,20.83032 32.4106047,16.44944 C32.4106047,15.51032 32.3034419,14.48832 32.132093,13.7816 C30.9661395,9.01152 26.680186,6.384 20.0634419,6.384 C19.4857674,6.384 18.8846512,6.41592 18.2712558,6.46576 C21.2706977,2.11232 28.5510698,1.7388 30.8673488,1.7388 C31.3010233,1.7388 31.7268837,1.75504 32.1443721,1.77912 C34.5086512,1.91184 46.3010233,3.0184 46.3010233,11.80368 C46.3010233,15.67048 41.8978605,22.8032 33.9019535,31.8864 Z M23.9553488,37.89016 L23.5473488,38.81864 C23.0517209,39.94648 21.8277209,40.4516 20.8353488,40.4516 C20.3436279,40.4516 19.3306047,40.1184 18.847814,39.73032 C8.78455814,31.64448 2.73655814,25.11936 1.8184186,21.35784 C1.68223256,20.80232 1.54325581,20.15384 1.54325581,19.5468 C1.54325581,13.82304 8.16781395,10.164 13.840186,8.7696 C16.0956279,8.21352 18.1903256,7.9324 20.0634419,7.9324 C23.4435349,7.9324 29.3106977,8.74048 30.631814,14.14896 C30.7752558,14.73528 30.8673488,15.638 30.8673488,16.44944 C30.8673488,22.19728 26.5412093,32.0208 23.9553488,37.89016 Z M32.2308837,0.23352 C31.7843721,0.20776 31.3294884,0.1904 30.8673488,0.1904 C28.1670698,0.1904 19.303814,0.68208 16.3573953,6.69536 C15.4236279,6.83872 14.4658605,7.02072 13.471814,7.26488 C7.25693023,8.79368 0,12.92648 0,19.5468 C0,20.31848 0.161302326,21.08176 0.318697674,21.72632 C1.59906977,26.9696 10.5767442,35.06832 17.8822326,40.93824 C18.5977674,41.51392 19.9501395,42 20.8353488,42 C22.6582326,42 24.2773953,40.99648 24.9594419,39.44304 L25.368,38.51568 C25.9110698,37.28088 26.5317209,35.86968 27.1724651,34.36104 C27.9220465,35.13384 29.0394419,35.80584 30.096,35.80584 C31.2904186,35.80584 32.8141395,35.462 35.0589767,32.91232 C40.8915349,26.28472 47.8442791,17.24296 47.8442791,11.80368 C47.8442791,3.91104 39.4336744,0.63728 32.2308837,0.23352 L32.2308837,0.23352 Z" id="Fill-1"></path>\
                                    </g>\
                                </g>\
                            </g>\
                        </g>\
                    </svg>\
                '
                };

                ctrl.SignIn = function () {
                    console.log('signing in');
                    ctrl.signedIn = true;
                };

                ctrl.SignOut = function () {
                    console.log('signing out');
                    ctrl.signedIn = false;
                };

                ctrl.close = close;

                setViewModelData();

                $scope.$watch('ctrl.serverViewModel', function (newValue, oldValue) {
                    setViewModelData();
                });

                function close() {
                    $rootScope.$broadcast('topNavClose');
                }

                function setViewModelData() {
                    // TODO: Format raw data from server VM to suit needs in this view.

                    // Dummy Data
                    ctrl.tier = DEFAULT_TIER;
                    ctrl.tier.svg = $sce.trustAsHtml(ctrl.tier.icon);
                    ctrl.firstName = 'Ann';
                    ctrl.lastName = 'Perkins';
                    ctrl.points = '312';
                    ctrl.signedIn = false;
                    ctrl.pointsStatus = 'Celebrity';
                }

                $scope.init = function() {
                    $http.get("/rpc/membership/account/rewards-status?" + new Date().getTime()
                        /* date added to prevent IE11 from caching this api call (results in wrong info displayed after logging out) */)
                        .then(function (d) {
                            if (d.data.Success == true) {
                                var model = d.data.Data;
                                ctrl.firstName = model.FirstName;
                                ctrl.lastName = model.LastName;
                                ctrl.points = model.Points;
                                ctrl.signedIn = model.SignedIn;
                            }

                            ctrl.apiCallFinished = true;
                        });
                };

                $scope.init();
            }]);
})();
